import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../core'

// { countryCode: '1', number: '123-456-7890', type: 'mobile', preferred: false, verified: false, note: '' }
export const RESOURCE = {
  payload: {
    description: 'Information about phone number',
    name: 'Phone Number',
    partialId: PartialId.Standard.create('phone_number'),
  },
  type: core.quiver.Resource.Type.DmsStructure,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsStructure>
